export default __webpack_public_path__ + "static/media/BG.f97d1b0b.png";